import React from 'react';
import { number, string, func, shape, arrayOf } from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { WithLoading } from '@widergy/energy-ui';

import UTCheckList from 'app/components/UTCheckList';
import { RELATED_ACCOUNTS } from 'constants/reduxForms';
import { message } from 'utils/stringUtils';

import styles from './styles';

import { RELATED_ACCOUNT_LIST } from './index';

const headers = [{ text: message('Accounts:clientNumber') }, { text: message('Commons:address') }];

const formatList = list => list.map(item => ({ ...item, id: item.client_number }));

const RelatedAccounts = ({ relatedAccounts, onSubmit }) => (
  <form onSubmit={onSubmit} style={styles.form}>
    <Field
      name={RELATED_ACCOUNT_LIST}
      list={formatList(relatedAccounts)}
      component={UTCheckList}
      header={headers}
      withoutLabel
      checked
    />
  </form>
);

RelatedAccounts.propTypes = {
  relatedAccounts: arrayOf(
    shape({
      id: number,
      address: string,
      client_number: number
    })
  ),
  onSubmit: func.isRequired
};

const form = reduxForm({ form: RELATED_ACCOUNTS })(RelatedAccounts);

export default WithLoading(props => props.loading)(form);
